import React, { useState } from 'react';

import YouTube from '@mui/icons-material/YouTube';

import Video from '../../../pages/activities/Video'
import ActivityButton from './ActivityButton';

import Congratulations from '../Congratulations';
import { useCode } from '../../../contexts/Code';


const ActivityGoogleForm = ({session}) => {
  const {code} = useCode()

  const [openVideo, setOpenVideo] = useState(false);
  const [finish, setFinish] = useState(false);

  return (
    <>

      {/* <iframe src='https://docs.google.com/forms/d/e/1FAIpQLSdkySTio0OjRAgdalW6XOE1eiGdRywqTj_6Fn93PGNLyxGpGg/viewform'></iframe> */}
      <Congratulations fire={finish} message={'¡Felicidades, has acumulado 100 puntos!'}/>

      <ActivityButton
        title="Responder encuesta"
        subtitle="+100 puntos"
        icon={<YouTube />}
        iconColor="error"
        clickWrapper={(e) => {
          window.open('https://docs.google.com/forms/d/e/1FAIpQLSdkySTio0OjRAgdalW6XOE1eiGdRywqTj_6Fn93PGNLyxGpGg/viewform', '_blank');
          setFinish(true);
          localStorage.setItem(code+session.id+'go', 'true')
        }}
        showScore={true}
        check={finish}
        image={"https://i.imgur.com/XSOZyTe.jpg"}
      />
    </>
  );
};

export default ActivityGoogleForm;
